import { buildResourceUrl } from 'services/mediaStorage'

import { QR_TYPE, TQrContent } from '../../generatorTypes'
import type { TPdfContent } from './PdfContentState'

export const getDirectPdfUrl = (content: TQrContent): string | undefined => {
	if (content.type !== QR_TYPE.Pdf) {
		return undefined
	}
	const { isDirect, file } = content as TPdfContent
	return isDirect && file?.publicId ? buildResourceUrl(file) : undefined
}
